module.exports = __webpack_public_path__ + "media/images/icons/table-b894bc6b9ee2321faca315564ca94f38.svg";